module.exports = __webpack_public_path__ + "static/specSheet-91d8931292f00cb37f3b8e145a7b6ac6.svg";